import { Card, Typography } from "@mui/material"
import { memo, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setOnDrop } from "../../../reducers/articleDragSlice"
import { selectTargetNote } from "../../../reducers/targetNoteSlice"
import { selectMovingNote } from "../../../reducers/moveNoteSlice"
import {clearNoteAction, NOTE_ACTIONS, selectNoteAction} from "../../../reducers/noteActionSlice"
import EditNote from "./EditNote"
import { smoothScrollTo } from "../../../utils/domUtilities"
import AddNote from "./AddNote"
import {selectCopyNoteId} from "../../../reducers/copyNoteSlice"
import {getLastRecordedNoteTreeScrollPosition} from "../../../reducers/WorkspacePanelScrollSlice"
import NoteCounters from "./NoteCounters"
//import AddNote from "./AddNote"

const Note = ({note, index}) => {
	const node = useRef(null)
	const {workspaceId} = note
	const [isDragHover, setIsDragHover] = useState(false)
	const dispatch = useDispatch()
	const targetNote = useSelector((state) => selectTargetNote(state, workspaceId))
	const movingNote = useSelector((state) => selectMovingNote(state,workspaceId))
	const noteAction = useSelector((state) => selectNoteAction(state, workspaceId))
	const copyNoteId = useSelector(selectCopyNoteId)
	const lastRecordedScrollPositionOfNoteTree = useSelector(getLastRecordedNoteTreeScrollPosition)
	const isCopyOrMovingNote = movingNote?.id === note?.id || copyNoteId === note?.id
	const noteInTargetNotePath = targetNote.path.indexOf(note?.id) !== -1
	const noteIsSelected = targetNote.id == note?.id

	const handleDrop = (event) => {
		event.preventDefault()
		dispatch(setOnDrop({note}))
		setIsDragHover(false)
	}

	const handleDragOver = (event) => {
		event.preventDefault() 
		if (!isDragHover ) {
			setIsDragHover(true)
		}
	}

	const handleDragLeave = (event) => {
		event.preventDefault()
		setIsDragHover(false)
	}

	useEffect(() => {
		if (noteAction.action === NOTE_ACTIONS.scrollToNote) {
			if (noteAction.noteId === note?.id) {
				const panelScroll = document.getElementById("note-panel-scroll")
				const rect = node.current.getBoundingClientRect()
				const panelRect = panelScroll.getBoundingClientRect()
				const topPosition = (rect.top - panelRect.top) + panelScroll.scrollTop - 128
				setTimeout(() => {
					smoothScrollTo(panelScroll, topPosition, 125, lastRecordedScrollPositionOfNoteTree)
					dispatch(clearNoteAction(workspaceId))
				}, 200)
			}
		}
	}, [noteAction, dispatch, note, note?.loadingChildren])

	const dragClasses = () => {
		if (noteIsSelected) {
			return "isOverTargetNote"
		}
		if (isCopyOrMovingNote) {
			return "isOverMovingNote"
		}

		return "isOverNote"
	}

	return(
		<div
			id={`note-${note?.id}-div-wrapper`}
			style={{
				alignItems: "center",
				width: "100%",
			}}
		>
			{ noteAction.action === NOTE_ACTIONS.addSibling && noteAction.noteId === note?.id && (
				<AddNote note={note} />
			)}
			<Card
				ref={node}
				id={`note-${note?.id}-card-wrapper`}
				onDrop={handleDrop}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				variant={"note"}
				className={isDragHover ? dragClasses() : "notOver"}
				sx={{
					display: "flex",
					alignItems: "stretch",
					width: "100%",
					backgroundColor: "white",
					borderLeftWidth: "5px",
					borderRightWidth: "5px",
					borderLeftStyle: "solid",
					borderRightStyle: "solid",
					borderLeftColor: "white",
					borderRightColor: "white",
					...(noteInTargetNotePath && !isCopyOrMovingNote && {
						borderLeftColor: "primary.main",
						borderRightColor: "primary.main",
					}),
					...(noteIsSelected && {
						borderLeftColor: "primary.main",
						borderRightColor: "primary.main",
						backgroundColor: "notes.selected",
					}),
					...(isCopyOrMovingNote && {
						backgroundColor: "notes.moveNoteIndicator",
						borderLeftColor: "notes.moveNoteIndicatorAccent",
						borderRightColor: "notes.moveNoteIndicatorAccent",
					}),
					"&:hover": {
						borderLeftColor: isCopyOrMovingNote
							? "notes.moveNoteIndicatorAccent"
							: (noteIsSelected || noteInTargetNotePath
								? "primary.main"
								: "notes.hoverBg"
							),
						backgroundColor: isCopyOrMovingNote
							? "notes.moveNoteIndicator"
							: (targetNote.id === note?.id
								? "notes.selected"
								: "notes.hoverBg"
							),
						borderRightColor: isCopyOrMovingNote
							? "notes.moveNoteIndicatorAccent"
							: (noteIsSelected || noteInTargetNotePath
								? "primary.main"
								: "notes.hoverBg"
							),
					},
				}}
			>
				{noteAction.action === NOTE_ACTIONS.editNote && noteAction.noteId === note?.id ? (
					<EditNote note={note} index={index} />
				) : (
					<Typography
						variant={"body1"}
						sx={{
							padding: "5px 10px",
							marginBottom: 0,
							wordBreak: "break-word"
						}}
						paragraph
					>
						{note?.content}
					</Typography>
				)}
				<span style={{ flexGrow: 1 }} />
				<NoteCounters note={note} noteInPath={noteInTargetNotePath} />
			</Card>
			{ noteAction.action === NOTE_ACTIONS.addChild && noteAction.noteId === note?.id && (
				<AddNote note={note} inNotePath={noteInTargetNotePath} />
			)}
		</div>
	)
}

export default memo(Note)